/**
 * 점주 콘솔 v2 라우트 테이블.
 *
 * 접근 조건(category/capability/permission)은 navigation.js의 NAVIGATION_ITEMS가
 * 단일 소스이고, 여기서는 key → 페이지 컴포넌트만 바인딩한다.
 * 모든 라우트는 RequireAccess로 감싸져 URL 직접 접근 시 권한 없음 화면이 표시된다.
 */
import Dashboard from './core/Dashboard';
import Members from './core/Members';
import MembershipPlans from './core/MembershipPlans';
import UsageHistory from './core/UsageHistory';
import Payments from './core/Payments';
import Notices from './core/Notices';
import Settings from './core/Settings';
import AuditLogs from './core/AuditLogs';
import LaunchSignups from './core/LaunchSignups';
import WebsiteStores from './core/WebsiteStores';

import Vehicles from './modules/carwash/Vehicles';
import LprLogs from './modules/carwash/LprLogs';
import KioskStatus from './modules/carwash/KioskStatus';
import WashPrograms from './modules/carwash/WashPrograms';
import RfCards from './modules/carwash/RfCards';
import DataQuality from './modules/carwash/DataQuality';
import Jj001WashReports from './modules/carwash/Jj001WashReports';

import Students from './modules/academy/Students';
import Parents from './modules/academy/Parents';
import Classes from './modules/academy/Classes';
import AcademyAttendance from './modules/academy/Attendance';

import GymAttendance from './modules/gym/Attendance';
import Lockers from './modules/gym/Lockers';
import Lessons from './modules/gym/Lessons';

import Machines from './modules/laundry/Machines';
import Orders from './modules/laundry/Orders';
import Pickup from './modules/laundry/Pickup';

import { NAVIGATION_ITEMS } from './navigation';

const PAGE_COMPONENTS = {
  dashboard: Dashboard,
  members: Members,
  membershipPlans: MembershipPlans,
  usageHistory: UsageHistory,
  payments: Payments,
  notices: Notices,
  settings: Settings,
  auditLogs: AuditLogs,
  launchSignups: LaunchSignups,
  websiteStores: WebsiteStores,
  vehicles: Vehicles,
  lprLogs: LprLogs,
  kioskStatus: KioskStatus,
  washPrograms: WashPrograms,
  rfCards: RfCards,
  dataQuality: DataQuality,
  jj001WashReports: Jj001WashReports,
  students: Students,
  parents: Parents,
  classes: Classes,
  attendance: AcademyAttendance,
  gymAttendance: GymAttendance,
  lockers: Lockers,
  lessons: Lessons,
  machines: Machines,
  orders: Orders,
  pickup: Pickup,
};

/** [{ ...navigationItem, Component }] — OwnerConsoleApp에서 <Route>로 펼친다 */
export const CONSOLE_ROUTES = NAVIGATION_ITEMS.map((item) => ({
  ...item,
  Component: PAGE_COMPONENTS[item.key],
}));
